import { DataTable, STATUSPAGE } from '@repo/ui';
import noDataBg from 'presentation/app/assets/images/no-task.png';
import { PerformanceReportForProfessionalsDetailedRow } from 'presentation/app/modules/Reports/models/performance-report-for-professionals';
import { useEffect, useState } from 'react';
import { SortOrder, TableColumn } from 'react-data-table-component';
import { Card, CardBody, CardHeader } from 'reactstrap';

import { makePerformanceReportForProfessionalsColumns } from '../../../../../common/columns/professionals/performance-report-for-professionals-columns';

interface IProps {
  total: number;
  loading: STATUSPAGE;
  currentPage: number;
  rowsPerPage: number;
  detailedList: PerformanceReportForProfessionalsDetailedRow[];
  onSearch: (value: string) => void;
  onChangePage: (page: number) => void;
  onChangeRowsPerPage: (currentRowsPerPage: number, page: number) => void;
  onSort: (
    selectedColumn: TableColumn<PerformanceReportForProfessionalsDetailedRow>,
    sortDirection: SortOrder,
  ) => void;
}

export const PerformanceReportResultsTable = ({
  total,
  onSort,
  loading,
  onSearch,
  currentPage,
  rowsPerPage,
  detailedList,
  onChangePage,
  onChangeRowsPerPage,
}: IProps) => {
  const [isSearchPending, setIsSearchPending] = useState(false);

  useEffect(() => {
    if (loading !== STATUSPAGE.LOADING) {
      setIsSearchPending(false);
    }
  }, [loading]);

  return (
    <Card>
      <CardHeader className="border-bottom">
        <div>
          <h5 className="mb-1 text-body">Ranking de desempenho</h5>
          <p className="text-muted mb-0">
            Listagem detalhada dos profissionais com base nos filtros
            selecionados.
          </p>
        </div>
      </CardHeader>

      <CardBody>
        <DataTable
          canSearch
          sortServer
          pagination
          actions={[]}
          searchServer
          onSort={onSort}
          paginationServer
          onSearch={(value) => {
            setIsSearchPending(true);
            onSearch(value);
          }}
          data={detailedList}
          noDataBg={noDataBg}
          noDataVariant="filter"
          defaultSortAsc={false}
          defaultSortFieldId={1}
          paginationTotalRows={total}
          onChangePage={onChangePage}
          defaultRowsPerPage={rowsPerPage}
          paginationDefaultPage={currentPage + 1}
          onChangeRowsPerPage={onChangeRowsPerPage}
          columns={makePerformanceReportForProfessionalsColumns()}
          loading={loading === STATUSPAGE.LOADING || isSearchPending}
        />
      </CardBody>
    </Card>
  );
};
